import React from 'react';
export function Footer() {
  return <footer className="bg-slate-900 text-slate-400 py-8 md:py-12 border-t border-slate-800" data-id="element-45">
      <div className="max-w-6xl mx-auto px-4 text-center" data-id="element-46">
        <span className="text-white font-bold text-lg tracking-tight" data-id="element-47">
          SIC 360
        </span>
        <p className="mt-3 text-xs md:text-sm" data-id="element-48">
          © 2026 SIC 360 — RincónDocente360. Todos los derechos reservados.
        </p>
        <p className="mt-1 text-[10px] md:text-xs text-slate-500 uppercase tracking-widest" data-id="element-49">
          RincónDocente360 · Recursos profesionales para docentes argentinos
        </p>
      </div>
    </footer>;
}